/* unplugin-vue-components disabled */import script from "./HotelSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./HotelSelect.vue?vue&type=script&setup=true&lang=js"

import "./HotelSelect.vue?vue&type=style&index=0&id=bedc1a2e&lang=scss"

const __exports__ = script;

export default __exports__